'use client';

import { ReactNode, useRef } from 'react';
import { Provider } from 'react-redux';

import { AppStore, makeStore } from '@app/app-state';

export const StoreProvider = ({
    children,
    preloadedState,
}: { children: ReactNode } & Record<string, any>) => {
    const storeRef = useRef<AppStore | null>(null);
    if (!storeRef.current) {
        storeRef.current = makeStore({
            preloadedState,
            reduxWrapperMiddleware: undefined,
        });
    }

    return <Provider store={storeRef.current}>{children}</Provider>;
};
